import * as Actions from './type';
import {
  getToggleSettingsApi,
  updateToggleSettingsApi,
} from '../../api/settings/settings-apis';

// get toggle settings
export const getToggleSettings = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_TOGGLE_SETTINGS_REQUEST,
    });
    const { data } = await getToggleSettingsApi();
    dispatch({
      type: Actions.GET_TOGGLE_SETTINGS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_TOGGLE_SETTINGS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// update toggle settings
export const updateToggleSettings = (settings) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_TOGGLE_SETTINGS_REQUEST,
    });
    const { data } = await updateToggleSettingsApi(settings);
    dispatch({
      type: Actions.UPDATE_TOGGLE_SETTINGS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_TOGGLE_SETTINGS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
